// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
import Typeahead from 'fg-frontend/components/Typeahead';

/* import SelectDesign from './components/SelectDesign';
import Tooltip from './components/Tooltip';
import TriggerInViewport from './components/TriggerInViewport';
import Countdown from './components/Countdown';
import Execute from './components/Execute';
import FGUpload from './components/FGUpload';
import configureEshopComponents from './configureEshopComponents'; */
import SimpleCollapse from './components/SimpleCollapse';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import PhotoSwipe from './components/PhotoSwipe';
import WebGtmHandler from './components/WebGtmHandler';
import RedirectForm from './components/RedirectForm';
import GtmHandler from './components/GtmHandler';
import Toggler from './components/Toggler';
// import LazyImage from './components/LazyImage';
import ItemSlider from './components/ItemSlider';
import Header from './components/Header';
import Webslider from './components/Webslider';
import GoogleMap from './components/GoogleMap';
import HideMessage from './components/HideMessage';
import Poll from './components/Poll';
import ShowMorePhotos from './components/ShowMorePhotos';
import HistoryBack from './components/HistoryBack';
import UserCreditsTank from './components/UserCreditsTank';
import DataLayer from './components/DataLayer';
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
import 'flatpickr/dist/l10n/cs';
import Leaderboard from './components/Leaderboard';
import EshopFulltextAutocomplete from './components/EshopFulltextAutocomplete';
import GoogleRecaptcha from "fg-frontend/src/components/GoogleRecaptcha";

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'RadioSelect':
      return RadioSelect;
    case 'UserCreditsTank':
      return UserCreditsTank;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'Header':
      return Header;
    case 'UniversalPaginationButton':
      return UniversalPaginationButton;
    case 'WebGtmHandler':
      return WebGtmHandler;
    case 'RedirectForm':
      return RedirectForm;
    case 'GtmHandler':
      return GtmHandler;
    case 'Toggler':
      return Toggler;
    // case 'LazyImage':
    //   return LazyImage;
    case 'ItemSlider':
      return ItemSlider;
    case 'Webslider':
      return Webslider;
    case 'GoogleMap':
      return GoogleMap;
    case 'HideMessage':
      return HideMessage;
    case 'Poll':
      return Poll;
    case 'Typeahead':
      return Typeahead;
    case 'Datepicker':
      return Datepicker;
    case 'ShowMorePhotos':
      return ShowMorePhotos;
    case 'DataLayer':
      return DataLayer;
    case 'SimpleCollapse':
      return SimpleCollapse;
    case 'Leaderboard':
      return Leaderboard;
    case 'HistoryBack':
      return HistoryBack;
    case 'EshopFulltextAutocomplete':
      return EshopFulltextAutocomplete;
    case 'GoogleRecaptcha':
      return GoogleRecaptcha;
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
  }
};



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/configureWebComponents.js